import { connect } from 'react-redux';
import Locale      from '../../../locale';

import Calendar    from './calendar.jsx';

export default connect(
    // mapStateToProps
    state => ( {
        ariaLabels: {
            title: Locale.getString( state, 'calendar.content.titleLabel' ),
            prevMonth: Locale.getString( state, 'calendar.button.prevMonthLabel' ),
            nextMonth: Locale.getString( state, 'calendar.button.nextMonthLabel' ),
            prevYear: Locale.getString( state, 'calendar.button.prevYearLabel' ),
            nextYear: Locale.getString( state, 'calendar.button.nextYearLabel' ),
            prevDecade: Locale.getString( state, 'calendar.button.prevDecadeLabel' ),
            nextDecade: Locale.getString( state, 'calendar.button.nextDecadeLabel' ),
            instructions: Locale.getString( state, 'calendar.content.instructionsLabel' )
        }
    } ),
    // mapDispatchToProps
    {}
)( Calendar );
